import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SendContactEmailRequest } from '../../shared/models/send-contact-email-request';

@Injectable({
  providedIn: 'root'
})
export class CustomerService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'Customer');
  }

  sendEmail(request: SendContactEmailRequest): Observable<boolean> {
    return this.post<boolean>(request, 'SendEmail');
  }

}
